import {
  INITIAL_DEFAULT_PAGINATION,
  PaginatedComponentState,
  usePaginatedReducerWithLocalStorage,
} from '../commons'
import { packageUrls } from '@/config/urls/account/package'
import { useHttpFetcher } from '@/utils/http'

import {
  AccountPackageUpdatesPageable,
  ApiPageableResponse,
  WorkspaceSecurityImpactSearchForm,
} from '@/types/index.d'

export type useInstalledPackagesReducerProps = {
  workspaceId: string
  componentId: string
} & WorkspaceSecurityImpactSearchForm

export const DEFAULT_PAGINATION = { ...INITIAL_DEFAULT_PAGINATION, pageSize: 3 }

export function useInstalledPackagesReducer({
  workspaceId,
  componentId,
}: useInstalledPackagesReducerProps): ApiPageableResponse<AccountPackageUpdatesPageable> & {
  state: PaginatedComponentState
  setPaginationConfig: (value: any) => void
  setSort: (value: any) => void
} {
  const initialState = {
    componentId,
    pagination: DEFAULT_PAGINATION,
  }

  const { dispatchers, state, pagination } =
    usePaginatedReducerWithLocalStorage({
      componentId,
      initialState,
      workspaceId,
    })

  const { data, isLoading, error } =
    useHttpFetcher<AccountPackageUpdatesPageable>({
      url: packageUrls.getWorkspacePackagesUpdates({
        workspaceId,
        params: {
          ...pagination,
        },
      }),
    })

  return {
    data,
    error,
    isLoading,
    state,
    ...dispatchers,
  }
}
